import { useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import useWeb3 from '../../../hooks/useWeb3'
import useUpcomingProjects from '../useUpcomingProjects'
import { Container } from '../styled'
import { Box } from '../../../shared_components/UI/Box'
import { LabsCard } from '..'
import { HeroRight } from '../HomeHero'
import { OverflowingCarousel } from '../../../shared_components/Library/OverflowingCarousel'
import styled, { css } from 'styled-components'
import { defaultTransition, useShouldShowForThreshold } from '../../../theme'
import { StyledThemedButton } from '../../../shared_components/ThemedButton/styles'
import UpcomingPoolLoadingState from '../parts/LoadingStates/Upcoming'
import { Link } from 'react-router-dom'
import {
  ThemedAnchor,
  ThemedButton,
} from '../../../shared_components/ThemedButton'
import { boxGapMarginsCssRules } from '../../../shared_components/Header/styles'
import { H1, P } from '../../../shared_components/Library/Typeography'

type ChipNavButtonProps = {
  isActive?: boolean
  shouldHide?: boolean
  borderRadiusLeftHide?: boolean
  borderRadiusRightHide?: boolean
}

export const ChipNavButton = styled(StyledThemedButton) <ChipNavButtonProps>`
  color: ${({ theme, isActive }) =>
    isActive
      ? theme.semantics.zap.text.brandPrimary
      : theme.semantics.zap.text.primary};
  padding: 8px 12px;
  ${({ shouldHide }) =>
    shouldHide &&
    css`
      opacity: 0;
      max-width: 0;
      padding: 0;
      margin: 0;
      overflow: hidden;
      pointer-events: none;
      border: 0px solid transparent;
    `}
  ${({ borderRadiusLeftHide }) =>
    borderRadiusLeftHide &&
    css`
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    `}
  ${({ borderRadiusRightHide }) =>
    borderRadiusRightHide &&
    css`
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    `}

    img.chain-icon {
    max-width: 20px;
    filter: unset !important;
  }

  ${defaultTransition}
`

const HeroCont = styled(Box)`
  ${boxGapMarginsCssRules}
`

export default function Home() {
  const { poolsData } = useWeb3()
  useEffect(() => {
    ; (async () => {
      await poolsData.dispatchPoolsToStore('labs')
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const { pools: upcomingProjectsLabs, loading: loadingLabs } =
    useUpcomingProjects('labs')

  const yellowTitle = 'Private Prices,'
  const title = 'for the public'
  const description =
    'ZAP Labs unlocks private VC rounds for communities. All companies are vetted and have passed our detailed due diligence. '
  const isAtLeastMediumDisplaySize = useShouldShowForThreshold('medium')

  return (
    <Container>
      <Box dc padV="section">
        <HeroCont
          padT={32}
          jsb
          ac={isAtLeastMediumDisplaySize}
          dc={!isAtLeastMediumDisplaySize}
        >
          <Box dc mw="516px">
            {yellowTitle !== null && (
              <H1 c="text-brandPrimary" uc>
                {yellowTitle}
              </H1>
            )}
            <H1 s="3XL" uc twb>
              {title}
            </H1>
            <P padV="l" s="XL">
              {description}
            </P>
            <Box g={10}>
              <ThemedAnchor
                $styleType="primary"
                href="https://tally.so/r/w5xvZE"
                isMail
              >
                Apply for labs
              </ThemedAnchor>
              <Link to={'/article/zap-labs'}>
                <ThemedButton $styleType="tertiary" w="auto">
                  {'About Labs'}
                </ThemedButton>
              </Link>
            </Box>
          </Box>
          <HeroRight currentSlide={'labs'} />
        </HeroCont>
      </Box>
      {(loadingLabs || !!upcomingProjectsLabs.length) && (
        <Box dc padB="section">
          <Box ac g={8}>
            <ChipNavButton $styleType={'active-chip'}>All</ChipNavButton>
          </Box>
          <OverflowingCarousel g={32} padV="m">
            {loadingLabs &&
              Array(4)
                .fill(null)
                .map((_, i) => <UpcomingPoolLoadingState key={uuidv4()} />)}
            {!loadingLabs &&
              upcomingProjectsLabs?.map((pool) => (
                <LabsCard key={uuidv4()} pool={pool} />
              ))}
          </OverflowingCarousel>
        </Box>
      )}
    </Container>
  )
}
